<template>
  <ReportSimpleDataTable
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'warehouse',
        title: 'Warehouse',
        valueFieldName: '',
      },
    ]"
  />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportSimpleDataTable from "@/own/components/reports/ReportSimpleDataTable.vue";
export default {
  name: "ReturnReport",
  components: { ReportSimpleDataTable },
  data: () => ({
    urls: {
      data_url: "/reports/returnReport",
      show_url: "/reports/returnReport/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
